export const BRAND_NAME = "Star Walk";
export const COPYRIGHT_LINK = "https://vitotechnology.com";
export const COMPANY_NAME = "Vito Technology, Inc.";
